"use client"

import { Button } from "@/components/ui/button"

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function OrderDetailError({ reset }: ErrorProps) {
  return (
    <section className='rounded-2xl border bg-white p-6 shadow-xs md:p-8'>
      <div className='flex min-h-[400px] flex-col items-center justify-center gap-4 text-center'>
        <h2 className='font-semibold text-2xl'>Erro ao carregar pedido</h2>
        <p className='text-muted-foreground'>
          Ocorreu um erro ao carregar os detalhes do pedido. Por favor, tente
          novamente.
        </p>
        <div className='flex gap-2'>
          <Button onClick={reset}>Tentar novamente</Button>
          <Button asChild variant='outline'>
            <a href='/minha-conta/pedidos'>Voltar para pedidos</a>
          </Button>
        </div>
      </div>
    </section>
  )
}
